import type { Plan, Subscription, Tenant } from "../models";
import { DEMO_TENANT_ID, DEMO_TENANT_SLUG } from "../../auth/auth.constants";

const now = () => new Date().toISOString();

export const PLAN_STARTER_ID = "plan-starter";
export const PLAN_BUSINESS_PRO_ID = "plan-business-pro";
export const PLAN_ENTERPRISE_ID = "plan-enterprise";

export const SUBSCRIPTION_DEMO_ID = "sub-demo-001";

const trialEnd = new Date();
trialEnd.setDate(trialEnd.getDate() + 23);

export const SEED_PLANS: Plan[] = [
  {
    id: PLAN_STARTER_ID,
    code: "starter",
    name: "Starter",
    description: "Pour les petites équipes",
    monthlyPrice: 49,
    yearlyPrice: 470,
    maxUsers: 10,
    maxStorageGb: 25,
    features: ["employees", "attendance", "tickets"],
    active: true,
  },
  {
    id: PLAN_BUSINESS_PRO_ID,
    code: "business_pro",
    name: "Business Pro",
    description: "Suite RH complète",
    monthlyPrice: 149,
    yearlyPrice: 1430,
    maxUsers: 50,
    maxStorageGb: 100,
    features: [
      "employees",
      "payroll",
      "recruitment",
      "crm",
      "tickets",
      "assets",
    ],
    active: true,
  },
  {
    id: PLAN_ENTERPRISE_ID,
    code: "enterprise",
    name: "Enterprise",
    description: "Multi-sites et SSO",
    monthlyPrice: 399,
    yearlyPrice: 3830,
    maxUsers: 500,
    maxStorageGb: 1000,
    features: ["all", "sso", "audit", "api"],
    active: true,
  },
];

export const SEED_TENANTS: Tenant[] = [
  {
    id: DEMO_TENANT_ID,
    name: "Démo ITaaS",
    slug: DEMO_TENANT_SLUG,
    domain: `${DEMO_TENANT_SLUG}.itaas.local`,
    status: "trial",
    planId: PLAN_BUSINESS_PRO_ID,
    subscriptionStatus: "trial",
    trialEndsAt: trialEnd.toISOString(),
    timezone: "Africa/Kinshasa",
    language: "fr",
    currency: "USD",
    createdAt: now(),
    updatedAt: now(),
  },
  {
    id: "tenant-acme",
    name: "Acme Corp",
    slug: "acme",
    domain: "acme.itaas.local",
    status: "active",
    planId: PLAN_ENTERPRISE_ID,
    subscriptionStatus: "active",
    timezone: "Africa/Kinshasa",
    language: "fr",
    currency: "USD",
    createdAt: now(),
    updatedAt: now(),
  },
  {
    id: "tenant-platform",
    name: "ITaaS Platform",
    slug: "platform",
    domain: "platform.itaas.local",
    status: "active",
    planId: PLAN_ENTERPRISE_ID,
    subscriptionStatus: "active",
    timezone: "UTC",
    language: "en",
    currency: "USD",
    createdAt: now(),
    updatedAt: now(),
  },
];

export const SEED_SUBSCRIPTIONS: Subscription[] = [
  {
    id: SUBSCRIPTION_DEMO_ID,
    tenantId: DEMO_TENANT_ID,
    planId: PLAN_BUSINESS_PRO_ID,
    status: "trial",
    billingCycle: "monthly",
    price: 149,
    startDate: now(),
    trial: true,
    currentUsers: 12,
    currentStorageGb: 18,
    createdAt: now(),
    updatedAt: now(),
  },
  {
    id: "sub-acme-001",
    tenantId: "tenant-acme",
    planId: PLAN_ENTERPRISE_ID,
    status: "active",
    billingCycle: "yearly",
    price: 3830,
    startDate: now(),
    trial: false,
    currentUsers: 87,
    currentStorageGb: 245,
    createdAt: now(),
    updatedAt: now(),
  },
  {
    id: "sub-platform-001",
    tenantId: "tenant-platform",
    planId: PLAN_ENTERPRISE_ID,
    status: "active",
    billingCycle: "yearly",
    price: 0,
    startDate: now(),
    trial: false,
    currentUsers: 5,
    currentStorageGb: 12,
    createdAt: now(),
    updatedAt: now(),
  },
];

export function cloneSeedData(): {
  tenants: Tenant[];
  plans: Plan[];
  subscriptions: Subscription[];
} {
  return {
    tenants: structuredClone(SEED_TENANTS),
    plans: structuredClone(SEED_PLANS),
    subscriptions: structuredClone(SEED_SUBSCRIPTIONS),
  };
}
